/**************************************************************************
Name:         formInput.js
Description:  Site scripting for instant feed of forms.
Date Created: 10/20/2015; Nick Guidry

**************************************************************************/

function formInput(options){
	this.config = {
		formID : '',
		formURL : '/',
		honeypot : '',
		submitButtonSelector : '.formSubmit',
		resetButtonSelector : '',
		ajaxSuccess : function(response, self){
			/* Responds to the ajax request */
			if(response.success){
				$(self.config.formSubmitBtn).addClass('disabled');
				self.resetForm();
			}
			else{
				self.handleErrors(response.errors);
				$(self.config.formSubmitBtn).removeClass('disabled');
			}
		},
		ajaxError : function(error, self){
			$(self.config.formSubmitBtn).removeClass('disabled');
		},
		preAjaxFunction : function(){ return; },
		validSubmitHTML : null,
		invalidSubmitHTML : null,
		formSubmitBtn : '',
		formResetBtn : '',
		checkMark : '<i class="fa fa-check-circle"></i>',
		useAjax: true,
		allowSubmitWithError: false
	};

	this.validateInput = function(el){
		/* Validates a single form input */
		var returnStr = {
				"valid" : true,
				"msg" : "",
				"showOnKeyUp": false
			};
		switch(el.attr('data-type')){
			case 'email':
				if(!this.validateEmail(el.val())){
					returnStr.valid = false;
	 				returnStr.msg = "That email is not valid.";
				}
				break;
			case 'text':
				if(!this.validateText(el.val())){
					returnStr.valid = false;
					returnStr.showOnKeyUp = true;
			 		if (el.attr('data-msg-len') == "lg"){
	 					returnStr.msg = "Sorry, I only accept alphanumeric characters—it's a security thing.";
			 		}
			 		else{
	 					returnStr.msg = "Oops! I didn't like that character.";
			 		}
				}
				break;
			case 'phone':
				if(!this.validatePhone(el.val())){
					returnStr.valid = false;
	 				returnStr.msg = "That phone is not valid.";
				}
				break;
			case 'idselect':
				if (el.val() == 0){
					returnStr.valid = false;
					if( el.attr('data-required') == 'true'){
						returnStr.msg = "Oops!";
					}
					else{
						returnStr.msg = "";
					}

				}
				break;
			case 'radio':
				if(jQuery(el).find("input[type='radio']:checked").length === 0){
					returnStr.valid = false;
	 				returnStr.msg = "";
				}
				break;
			case 'checkbox':
				if (!$(el).find("input[type='checkbox']:checked").length){
					returnStr.valid = false;
	 				returnStr.msg = "Check at least one box";
				}
				break;
			default:
				break;
		}
		if(el.is("input") || el.is("textarea") || el.is("select")){	//Only check that the element has a value if it can contain one
			if( el.attr('data-required') == 'true' && el.val() == ''){
				returnStr.valid = false;
				returnStr.showOnKeyUp = false;
				//Find the label for the element
				let label = el.closest("label");
				if(label.length === 0){
					label = jQuery(`${this.config.formID} label[for="${el.attr("name")}"]`);
				}
				//Get the label's text
				let labelText = "";
				for(let i=0; i<label[0].childNodes.length; i++){
					if(label[0].childNodes[i].nodeType === 3){	//Text nodes
						labelText += label[0].childNodes[i].textContent;
					}
					else if(label[0].childNodes[i].classList.contains("formHelp")){
						continue;	//Skip help/error text in the label
					}
					else if(label[0].childNodes[i].classList.contains("iti")){
						continue;	//Skip phone number inputs
					}
					else if((new Set(["input","select","textarea"])).has(label[0].childNodes[i].tagName.toLowerCase())){
						continue;	//Skip form elements
					}
					else{
						let childStyle = getComputedStyle(label[0].childNodes[i]);
						if(isNaN(parseInt(childStyle.opacity)) || parseFloat(childStyle.opacity) < 0.2){
							continue;	//Skip transparent elements
						}
						else if(childStyle.display === "none" || childStyle.visibility === "hidden"){
							continue;	//Skip hidden elements
						}
						else{	//Copy the label's text
							labelText += jQuery(label[0].childNodes[i]).clone().children().remove().end().text();
						}
					}
				}
				labelText = labelText.trim().replace(/\s+/g, " ");
				if(labelText.length > 0 && (new Set(["a", "e", "i", "o", "u"])).has(labelText[0].toLowerCase())){
					labelText = "valid " + labelText.toLowerCase();
				}
				returnStr.msg = `A ${labelText} is required.`;
			 }
		}
		return returnStr;
	};

	this.validateEmail = function(email) {
		/* Validates an email input */
		var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
		return email.length === 0 || re.test(email);
	};

	this.validateText = function(text) {
		/* Validates a standard text field */
		var re = /^[a-zA-Z0-9 \.\-\?\$\%\&\!,'\r\n]+$/i;
		return text.length === 0 || re.test(text);
	};

	this.validatePhone = function(text) {
		//Imperfect solution but will work in most cases
		let validChars = /^[0-9\-()# .+]*$/.test(text);	//Check for invalid characters
		if(!validChars){
			return false;
		}
		let cleanText = text.replace(/[^0-9]/g,"");	//Remove all non-numeric characters
		return cleanText.length === 0 || (cleanText.length >= 10 && cleanText.length <= 15);
	};

	this.handleErrors = function(errors){
		$(this.config.formID + ' .formHelp').removeClass('error').text('');	//Clear existing errors
		let topLabel = document.body.scrollHeight;	//The top position of the first label
		for(var field in errors){
			var error = errors[field];
			//Get the label for the input with the error
			const getLabel = (fieldName)=>{
				let label = $(`${this.config.formID} label[for="${fieldName}"]`);
				if(label.length === 0){	//Fallback to checking if the label is wrapping the input
					label = $(`${this.config.formID} *[name='${fieldName}']`).closest("label");
				}
				return label;
			}
			let label = getLabel(field);
			if(label.length === 0 && field.toLowerCase() !== field){
				//The label could not be found, try again with a lowercase field name
				label = getLabel(field.toLowerCase());
			}
			console.info(field);
			console.log(label);
			//Show the error message
			label.find(".formHelp").addClass('error').text(error);
			if(label.length > 0){
				topLabel = Math.min(topLabel, (label[0].getBoundingClientRect().top + window.scrollY));
			}
		}
		//Check the scroll position of the top label
		topLabel -= 60;	//To prevent the nav bar from covering the label
		if(topLabel < window.scrollY){	//Don't scroll further down the page
			window.scrollTo({		//Scroll the label into view
				top: topLabel,
				left: 0,
				behavior: "smooth"
			});
		}
	};

	this.submitForm = function(){
		let form = $(this.config.formID);
		let self = this;

		if($(this.config.formSubmitBtn).hasClass('disabled')) {
			return false;
		}

		//honeypot
		if (this.config.honeypot.length != 0){
			let honeypot = $(this.config.formID + ' ' + this.config.honeypot);
			if(honeypot.length != 0){
				if ($(honeypot).val() != 0){
					return false;
				}
			}
		}

		if (typeof this.config.preAjaxFunction() === "function"){
			this.config.preAjaxFunction();
		}

		$(this.config.formSubmitBtn).addClass('disabled');

		//contact form submission google analytics:
		if(this.config.submitButtonSelector == '#contactFormSubmit' || this.config.submitButtonSelector == '#portraitContactFormSubmit'){
			if (typeof ga !== 'undefined'){
				ga('send', 'pageview', '/contact/thanks');
			}
			else{
				(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
					(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
					m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
					})(window,document,'script','//www.google-analytics.com/analytics.js','ga');

					ga('create', 'UA-8160605-1', 'auto');
					ga('send', 'pageview', '/contact/thanks');
			}
		}
		//contact form/consultation submission google adwords conversion:
		if(this.config.submitButtonSelector == '#contactFormSubmit' || this.config.submitButtonSelector == '#portraitContactFormSubmit' || this.config.submitButtonSelector == '#consultationFormSubmit'){
			googleAdWordsConversion();
		}
		$.ajax({
			type: "post",
			dataType: 'json',
			url: this.config.formURL,
			data: form.serialize(),
			success: function(response){
				self.config.ajaxSuccess(response, self);
			},
			error: function(error){
				self.config.ajaxError(error, self);
			}
		});
	};

	this.resetForm = function(){
		$(this.config.formID + ' input, ' + this.config.formID + ' textarea').each(function(){
			$(this).val('');
			let label = $(this).siblings('label[for="' + $(this).attr("name") + '"]');
			if(label.length === 0) label = $(this).closest("label");
			let formHelp = label.find('.formHelp');
			formHelp.removeClass('error');
			formHelp.html('');
		});
		$(this.config.formID + ' select').each(function(){
			$(this).val($(this).find("option:first").val());
			let label = $(this).siblings('label[for="' + $(this).attr("name") + '"]');
			if(label.length === 0) label = $(this).closest("label");
			let formHelp = label.find('.formHelp');
			formHelp.removeClass('error');
			formHelp.html('');
		});
	};

	this.validateAll = function() {
		/* Validates all inputs in the form */
		let self = this;
		let allValid = true;
		let oneValidFound = false;
		let requiredValid = true;
		let valid = true;
		let oneWithInput = false;
		jQuery(this.config.formID).find("input,textarea,select,.buttonGroup,*[data-input='true']").each(function(){
			//Check each form input for valid content
			if ($(this).css("display") != "none"){
				var currentValid = self.validateInput($(this));

				if($(this).attr('data-required') == "1" || $(this).attr('data-required') == "true" ){
					requiredValid = requiredValid && currentValid.valid;
				}

				if (!currentValid.valid && (($(this).attr('data-type') != "idselect" && $(this).val() !== "") || ($(this).attr('data-type') == "idselect" && $(this).val() !== "0"))){
					allValid = false;
				}

				if (currentValid.valid){
					oneValidFound = true;
				}

				if ((($(this).attr('data-type') != "idselect" && $(this).val() !== "") || ($(this).attr('data-type') == "idselect" && $(this).val() !== "0"))){
					oneWithInput = true;
				}
			}
		});

		//Determine whether the form is valid
		valid = requiredValid && oneValidFound && allValid;

		if(valid || (this.config.allowSubmitWithError && oneWithInput)){
			if(jQuery(this.config.formSubmitBtn).is(".disabled") || jQuery(this.config.formSubmitBtn).is("[disabled]")){
				//Only update the inner HTML if needed, doing this unneccessarily will prevent the button from submitting the form
				$(this.config.formSubmitBtn).removeClass('disabled').removeAttr("disabled");
				if(this.config.validSubmitHTML != null){
					$(this.config.formSubmitBtn).html(this.config.validSubmitHTML);
				}
			}
		}
		else{
			$(this.config.formSubmitBtn).addClass('disabled').attr("disabled", true);
			if(this.config.invalidSubmitHTML != null){
				$(this.config.formSubmitBtn).html(this.config.invalidSubmitHTML);
			}
		}
	};

	this.validateStart = function(parent, self, isKeyUp, relatedTarget=null){
		var formHelp = $(self).siblings('label[for="' + $(self).attr("name") + '"]').find('.formHelp');
		if(formHelp.length === 0){
			formHelp = self.closest("label").find(".formHelp");
		}
		var valid = parent.validateInput($(self));

		if( !valid.valid ){
			if (!isKeyUp || (valid.showOnKeyUp && isKeyUp)){
				formHelp.addClass('error');
				if (self.attr('show-msg') != 'false' ){
					formHelp.html(valid.msg);
				}
				else{
					formHelp.html('');
				}

			}
			else{
				formHelp.removeClass('error');
				formHelp.html('');
			}
		}
		else{
			formHelp.removeClass('error');
			formHelp.html(this.config.checkMark);
		}
		if(relatedTarget === null || jQuery(relatedTarget).is(":not([type='submit'])")){
			parent.validateAll();
		}
	};

	this.init = function(options) {
		Object.assign(this.config, options);
		let self = this;

		if (this.config.formSubmitBtn.length == 0){
			this.config.formSubmitBtn = this.config.formID + ' ' + this.config.submitButtonSelector;
		}

		if (this.config.resetButtonSelector.length != 0){
			this.config.formResettBtn = this.config.formID + ' ' + this.config.resetButtonSelector;
		}

		//Validates the input as the user types.
		$(this.config.formID + ' input, ' + this.config.formID + ' textarea').keyup(function(e){
			var charCode = e.which || e.keyCode; // for cross-browser compatibility
			if((charCode !== 9) && (charCode !== 16)){
				self.validateStart(self, $(this), true);
			}
		});

		//Validates the input on unfocus. Added to check auto complete.
		$(this.config.formID + ' input, ' + this.config.formID + ' textarea').blur(function(e){
			self.validateStart(self, $(this), false, e.relatedTarget);
		});

		//Validates select fields.
		$(this.config.formID + ' select').change(function(e){
			self.validateStart(self, $(this), false);
		});

		//Validates button choice.
		$(this.config.formID + ' input[data-type="buttonChoice"]').click(function(e){
			var buttonGroup = $(this).closest('.buttonGroup');
			self.validateStart(self, buttonGroup, false);
		});

		//Validates radio choice.
		$(this.config.formID + ' input[type="radio"], ' + this.config.formID + ' input[type="checkbox"]').change(function(e){
			var buttonGroup = $(this).closest('.buttonGroup');
			self.validateStart(self, buttonGroup, false);
		});

		//Masks telephone inputs
		let formID = this.config.formID;
		let maskOptions = {
			onKeyPress: function(cep, e, field, options){
				//Change the mask if more than 10 digits are entered (for international number support)
				let newMask = (cep.length > 14) ? " 000 000 000 000 000" : "(000) 000-0000 0";
				$(formID + ' input[type="tel"]').mask(newMask, maskOptions);
			}
		}
		$(this.config.formID + ' input[type="tel"]').mask("(000) 000-0000 0", maskOptions);

		if (this.config.useAjax){
			$(this.config.formID).on("submit", function(event){
				event.preventDefault();
				self.submitForm();
			});
		}

		if (this.config.formResetBtn.length != 0){
			$(this.config.formResetBtn).click(function(){
				self.resetForm();
			});
		}
	};

	this.init(options);
}

function googleAdWordsConversion(){
	var google_conversion_id = 1068496657;
	var google_conversion_language = "en";
	var google_conversion_format = "3";
	var google_conversion_color = "ffffff";
	var google_conversion_label = "gHLkCPzY-18Qke6__QM";
	var google_remarketing_only = false;


	(function(){var aw = document.createElement('script');
	aw.type = 'text/javascript';
	aw.async = true;
	aw.src = '//www.googleadservices.com/pagead/conversion.js';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(aw, s);})();

	i=document.createElement('img');
	i.width=1;i.height=1;
	i.src='//www.googleadservices.com/pagead/conversion/1068496657/?label=gHLkCPzY-18Qke6__QM&amp;guid=ON&amp;script=0';
	document.body.appendChild(i);

}
